import { jsx as _jsx } from "react/jsx-runtime";
var LockCircle = function LockCircle(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.40017 9.50002C9.40017 8.06408 10.5642 6.90002 12.0002 6.90002C13.4361 6.90002 14.6002 8.06408 14.6002 9.50002V11.092C15.4116 11.3468 16.0002 12.1049 16.0002 13.0004V15.0004C16.0002 16.105 15.1047 17.0004 14.0002 17.0004H10.0002C8.89559 17.0004 8.00016 16.105 8.00016 15.0004V13.0004C8.00016 12.1049 8.58874 11.3468 9.40017 11.092V9.50002ZM12.0002 8.10002C11.227 8.10002 10.6002 8.72682 10.6002 9.50002V10.9H13.4002V9.50002C13.4002 8.72682 12.7734 8.10002 12.0002 8.10002Z",
      fill: color
    })
  });
};
export default LockCircle;